module.exports = __webpack_public_path__ + "img/news_01.cd51b910.jpg";